import * as request from '@/utils/request'
let BaseUrl = '/paas/rick/whitelist'
export default {
	// --------------------------------------  下发限额白名单 -------------------------------------------
	/**
	 * @description 删除下发限额白名单
	 * @author daihua
	 * @date 2022/3/7
	 * @param {*} data
	 * @returns 
	 */
	deleteQuotaWhiteId(id) {
		return request.Delete(`${BaseUrl}/delete/${id}`)
	},
	/**
	 * @description 增加下发限额白名单
	 * @author daihua
	 * @date 2022/3/7
	 * @param {*} data
	 * @returns 
	 */
	postCreateQuotawhite(data) {
		return request.post(`${BaseUrl}/create`, data)
	},
	/**
	@description 下发限额白名单列表
	* @author daihua
	* @date 2022/3/7
	* @param {*} data
	* @returns 
	 */
	postQuotawhiteList(data) {
		return request.post(`${BaseUrl}/list`, data)
	},
	// 充值白名单列表
	rechargewhiteList(data) {
		return request.post(`/paas/recharge/whitelist/list`, data)
	},
	// 删除充值白名单列表
	delrechargewhiteList(id) {
		return request.Delete(`/paas/recharge/whitelist/delete/${id}`)
	},
	// 添加充值白名单列表
	addrechargewhiteList(data) {
		return request.post(`/paas/recharge/whitelist/create`,data)
	}
}
